import { findRecursive } from '@/mm/utils.js'

export function washData_expandCollapseText(walkedNode) {
  if (walkedNode._type === 'expandCollapse_text_style1') {
    const ProNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'button_text_border',
      'list'
    )
    const textNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'text_paragraph',
      'list'
    )
    const titleNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'text_title',
      'list'
    )
    if (ProNode) {
      if (!ProNode.actions[0].config['文字设计'].find((item) => item === 'self_textInput')) {
        ProNode.actions[0].config['文字设计'].unshift('self_textInput')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    if (textNode) {
      if (!textNode.actions[0].config['文本'].find((item) => item === 'title_textTheme')) {
        textNode.actions[0].config['文本'] = [
          'title_textTheme',
          'title_fontFamily',
          'title_fontSize',
          'title_color',
          'title_lineHeight',
          'title_letterSpace',
          'self_margin'
        ]
      }
    }

    if (titleNode) {
      titleNode.actions = [
        {
          name: 'design',
          groupLayout: 'topBottom',
          config: {
            设置: [
              'self_upperLowerCase',
              'title_textTheme',
              'title_fontFamily',
              'title_fontSize',
              'title_color',
              'self_background',
              'title_textStyle',
              'title_textAlign',
              'title_h',
              'title_lineHeight',
              'title_letterSpace',
              'self_margin',
              'self_padding'
            ]
          }
        }
      ]
    }
  } else if (walkedNode._type === 'expandCollapse_text_style2') {
    const ProNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'button_text_icon',
      'list'
    )
    const textNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'text_paragraph',
      'list'
    )
    const titleNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'text_title',
      'list'
    )
    if (ProNode) {
      if (!ProNode.actions[0].config['文字设计'].find((item) => item === 'self_textInput')) {
        ProNode.actions[0].config['文字设计'].unshift('self_textInput')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    if (textNode) {
      if (!textNode.actions[0].config['文本'].find((item) => item === 'title_textTheme')) {
        textNode.actions[0].config['文本'] = [
          'title_textTheme',
          'title_fontFamily',
          'title_fontSize',
          'title_color',
          'title_lineHeight',
          'title_letterSpace',
          'self_margin'
        ]
      }
    }

    if (titleNode) {
      titleNode.actions = [
        {
          name: 'design',
          groupLayout: 'topBottom',
          config: {
            设置: [
              'self_upperLowerCase',
              'title_textTheme',
              'title_fontFamily',
              'title_fontSize',
              'title_color',
              'self_background',
              'title_textStyle',
              'title_textAlign',
              'title_h',
              'title_lineHeight',
              'title_letterSpace',
              'self_margin',
              'self_padding'
            ]
          }
        }
      ]
    }
  }
}
